import * as React from "react";
import { connect } from "react-redux";
import { DispatchFunc } from "../../../../../../store/ActionTypes";
import { updateDescription } from "../../../../../../store/BookingDescription";
import { ReduxState } from "../../../../../../store/ReduxState";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import {
    Alignment,
    ButtonsWrapper,
    Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { ThemeBreakpoints, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalClose } from "../../../../../../utils/redux/ActionTypes";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Required } from "@vwpfs/mary-air-lib/components/air/05-atoms/Required";
import { FormField, FieldTypes } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

/**
 *
 */
interface OwnProps {
    modalID: string;
    statementLineId: string;
    onBookConfirmed: () => void;
}

/**
 *
 */
interface StateProps {
    bookingDescription: string;
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
    updateDescription: (description: string) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps & StateProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    bookingDescription: s.prop("bookingDescription"),
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
    updateDescription: (description: string) => dispatch(updateDescription(description)),
});

export const confirmBooking = (props: Props) => () => {
    props.onBookConfirmed();
    props.closeModal(props.modalID);
};

export const closeModal = (props: Props) => () => props.closeModal(props.modalID);

/**
 *
 * @param props
 */
const ConfirmBookingComp: React.FunctionComponent<Props> = (props) => (
    <FlexColumn
    >
        <FlexRow isFixed>
            <Navbar
                theme={{
                    palette: ThemePalette.CONTRAST_TERTIARY,
                }}
            >
                <NavbarStack>
                    <NavbarStackContent>
                        <NavbarTitle>
                            Booking Statement Line
                        </NavbarTitle>
                    </NavbarStackContent>
                    <NavbarStackRight>
                        <NavbarIcon>
                            <Button
                                icon={IconNames.TIMES}
                                link={{
                                    onClick: closeModal(props),
                                }}/>
                        </NavbarIcon>
                    </NavbarStackRight>
                </NavbarStack>
            </Navbar>
        </FlexRow>
        <FlexRow
            theme={{
                palette: ThemePalette.CONTRAST_PRIMARY,
            }}
        >
            <FlexColumn>
                <FlexRow isScrollable >
                    <FillUp>
                        <Container
                            theme={{
                                padding: {
                                    "": { y: 3 },
                                    "md": { y: 4 },
                                },
                            }}
                        >
                            <Div>
                                You are about to book on statement line ({props.statementLineId}).
                                <br /><br />
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Description"
                                    required
                                    placeholder="e.g. Booked today"
                                    onChange={(value?: string | number) =>
                                        props.updateDescription(value?.toString() ?? "")}
                                    value={props.bookingDescription}
                                />
                                <Required /><br /><br />
                                <b>Are you sure you want to book the selection on this statement line?</b>
                            </Div>
                        </Container>
                    </FillUp>
                </FlexRow>
            </FlexColumn>
        </FlexRow>
        <FlexRow isFixed>
            <FlexColumn
                theme={{
                    palette: ThemePalette.CONTRAST_SECONDARY,
                }}
            >
                <Container
                    theme={{
                        padding: { "": { y: 3 } },
                    }}
                >
                    <ButtonsWrapper
                        defaultOrientation={Orientation.HORIZONTAL}
                        orientations={{
                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                        }}
                        alignment={Alignment.RIGHT}
                    >
                        <Button
                            theme={{ palette: ThemePalette.CONTRAST_SECONDARY }}
                            link={{ onClick: closeModal(props)}}
                        >
                            Cancel
                        </Button>
                        <Button
                            theme={{ palette: ThemePalette.BRAND_ACCENT }}
                            link={{ onClick: confirmBooking(props)}}

                            disabled={!props.bookingDescription}
                        >
                            Yes
                        </Button>
                    </ButtonsWrapper>
                </Container>
            </FlexColumn>
        </FlexRow>
    </FlexColumn >
);

/**
 *
 */
export const ConfirmBookingModal = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ConfirmBookingComp);
